
$(function(){
  //for warranty product
  addWarrantyProduct();

var tooltipHtml = '<div class="tooltip_cart"> <div class="eliteimg"> <small> <img src="https://cdn.shopify.com/s/files/1/0056/5841/1042/files/information-3_24x.png?v=1665730670"> </small> </div><div class="tooltiptext"> <div class="scroll-bar-wrap"> <div class="scroll-box"> <span><p><b>1 YEAR GUARANTEE</b></p> <p>Enjoy a limited 1 year warranty on your entire order, crazy good discounts (already applied) and a free LL2 Light Launcher shipped with this order! </p> </span> </div> </div> </div> </div>';

document.addEventListener('rebuy:smartcart.hide', function(event){
  //console.log('rebuy:smartcart.hide event', event.detail); 
})

document.addEventListener('rebuy:smartcart.show', function(event){
  //console.log($(".rebuy-cart__progress-step-wrapper.count-4 > div").find(".threshold").length);
  if( !$(".rebuy-cart__progress-step-wrapper.count-4 > div").find(".threshold").length ){
    $(".rebuy-cart__progress-step-wrapper.count-4 > div:nth-child(1)").append("<span class='threshold'>$35</span>");
    $(".rebuy-cart__progress-step-wrapper.count-4 > div:nth-child(2)").append("<span class='threshold'>$50</span>");
    $(".rebuy-cart__progress-step-wrapper.count-4 > div:nth-child(3)").append("<span class='threshold'>$75</span>");
    $(".rebuy-cart__progress-step-wrapper.count-4 > div:nth-child(4)").append("<span class='threshold'>$100</span>");
  }
  
  $('.rebuy-cart__checkout-button').attr("disabled", true);
  
  //console.log('rebuy:smartcart.show event', event.detail); 
  addWarrantyProduct(function(){
    setTimeout(function(){
      $('.rebuy-cart__checkout-button').attr("disabled", false);
    },2000);
  });

  setTimeout(function(){
    $(".rebuy-cart__flyout-item .tooltip_cart").remove();
    $(".rebuy-cart__flyout-item.product-guarantee a.rebuy-cart__flyout-item-product-title").append(tooltipHtml);

    $(".rebuy-cart__progress-free-product-variant-select").find('option:eq(1)').attr("selected", "selected");
  }, 2000);
  
}); 

$(document).on("click", "#rebuy-cart .tooltip_cart", function(e){
  e.stopPropagation(); e.preventDefault();
})

$(document).on("click", ".rebuy-cart__progress-free-product-variant-select", function(e){
  //$(this).find('option:eq(1)').attr("selected", "selected");
  //$(this).find('option:eq(1)').click();
})


});

function addWarrantyProduct( callback=false ) {
  //console.log("addWarrantyProduct");
  if( wproduct ){   
      var add_warranty = true;
      var clearCart = false;
      //console.log(wproduct);

      (async () => {
          const resp = await fetch('/cart.js')
          cartOb = await resp.json()
          
          if(!cartOb.items.length) return
      
          cartOb.items.forEach(item => {
              if(item.handle == 'guarantee'){
                  //console.log('Warranty already in cart');
                add_warranty = false;
            
                  if(cartOb.items.length == 1)
                    clearCart = true;
                  
                  return false;
              }
          });
    
          if(clearCart){
              const resp = await fetch('/cart/clear.js')
              // return await resp.json()
              location.reload();
              // console
          }
      
          if(add_warranty){
              var quantity = 1;
              var variant_id = wproduct.variant; //'31356958507042'; 
              var Recharge_frequency = wproductMeta.shipping_interval_frequency; 
              var Recharge_unit_type = wproductMeta.shipping_interval_unit_type; 
              var subscription_id = wproductMeta.subscription_id; 
              addItemToCart(variant_id , 1, Recharge_frequency, Recharge_unit_type, subscription_id);
          }

          if(callback) callback();

      })()

  }
  else{
      if(callback) callback();
  }
  
  
}

function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
  data = {
      "quantity": quantity,
      "id": variant_id,
      "selling_plan": 688233775405
      }
      //"properties[shipping_interval_frequency]": shipping_interval_frequency, 
      //"properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
      //"properties[subscription_id]": subscription_id
  
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      async:false,
      dataType: 'json',
      success: function() { 
          console.log('recharge warranty added');
          if( window.location.href.indexOf("/cart") != -1 )
              window.location.href = '/cart';
      }
  });
}

Shopify.addItemFromForm = function(form_id, callback) {
  $('#' + form_id + ' ~ .boost-pfs-addtocart-btn').attr("data-before-content", "adding to cart");
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) { 
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        jQuery.getJSON('/cart.js', function(cart) {
          $('#' + form_id + ' ~ .boost-pfs-addtocart-btn').attr("data-before-content", "added to cart");
          $('#CartCount').text(cart.item_count);
          $('#CartCost').removeClass('money');
          var totalPrice = theme.Currency.formatMoney(cart.total_price, StyleHatch.currencyFormat);
          $('#CartCost').html('<span class="money">' + totalPrice + '</span>');    
          setTimeout(function(){
            $('#' + form_id + ' ~ .boost-pfs-addtocart-btn').attr("data-before-content", "add to cart");
          }, 1000);
        } );
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      $('#' + form_id + ' ~ .boost-pfs-addtocart-btn').attr("data-before-content", "add to cart");
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

document.addEventListener('DOMContentLoaded', function() {
var box1 = document.getElementById('search-mobile-icon-open');
var box2 = document.getElementById('search-mobile-container');
var box3 = document.getElementById('search-mobile-close');
box1.addEventListener('click', function() {
  box2.classList.toggle('open-search-mobile');
});
box3.addEventListener('click', function() {
  box2.classList.toggle('open-search-mobile');
});
});
